import { FC, memo, useMemo } from 'react';
import { MImage as Image } from '@shared/h5/components';
import dayjs from 'dayjs';
import { Ellipsis } from '@shared/h5/components';
import formatNumber from '@/common/utils/format-number';
import { Company } from '../../models/model';
import styles from './index.module.scss';

const CompanyCard: FC<{ company: Company }> = ({ company }) => {
  const companyInfo = useMemo(() => {
    let result = '';
    if (company.stage) {
      result += `${company.stage} · `;
    }
    if (company.people) {
      result += `${company.people}`;
    }
    if (company.domain) {
      result += ` · ${company.domain}`;
    }
    return result;
  }, [company.domain, company.people, company.stage]);

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.company_logo}>
          <Image
            width='64'
            height='64'
            alt={`${company.name}公司logo`}
            src={company.clogo || 'https://i9.taou.com/maimai/c/offlogo/default.png'}
            placeholder='blur'
            blurDataURL='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNs2AQAAbgBNMqymOwAAAAASUVORK5CYII='
          />
        </div>
        <div className={styles.company_info}>
          <h1 className={styles.title} title={`${company.name}人脉圈`}>
            {company.name}人脉圈
          </h1>
          <div className={styles.info}>{companyInfo}</div>
          <div className={styles.desc}>
            {!!company.follower_cnt && (
              <span className={styles.desc_item}>
                <span>{formatNumber(company.follower_cnt)}</span> 关注
              </span>
            )}
            {!!company.recent_job_cnt && (
              <span className={styles.desc_item}>
                <span>{formatNumber(company.recent_job_cnt)}</span> 职位
              </span>
            )}
            {!!company.employee_cnt && (
              <span className={styles.desc_item}>
                <span>{formatNumber(company.employee_cnt)}</span> 员工在脉脉
              </span>
            )}
            <span className='float-right hidden text-gray-600 md:inline-block'>
              更新：{dayjs().format('YYYY-MM-DD')}
            </span>
          </div>
        </div>
      </div>
      <div className={styles.company_content}>
        <Ellipsis direction='end' content={company.intro} rows={2} expandText='展开' collapseText='收起' />
      </div>
    </div>
  );
};

export default memo(CompanyCard);
